'use strict';

import Accordion from "../_modules/paragraph--type--accordion/paragraph--type--accordion";

window.$ = jQuery;

// Document ready function



$(() => {
    new Accordion().init();
});


